import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import logo from '../assets/ranky-logo-text-blue.png';

import "../style/MobileHeader.css";

// MobileHeader Component
class MobileHeader extends Component {
  constructor() {
      super();
      this.state = {
        isMenuOpen : false,
      };
      this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu() {
      this.setState({ isMenuOpen : !this.state.isMenuOpen });
  }

  render() {
    const menu = (
        <div className="menu-wrapper">
            <ul className="vertical-nav-menu">
                <li className="heading">Menu</li>
                <li>
                    <NavLink className="nav-link" onClick={this.toggleMenu} to='/app' exact activeClassName="active">
                        <i className="pe-7s-rocket menu-icon"></i>
                        Accueil
                    </NavLink>
                </li>
                <li>
                    <NavLink className="nav-link" onClick={this.toggleMenu} to='/app/etablissements' activeClassName="active">
                        <i className="pe-7s-graph2 menu-icon"></i>
                        Mes établissements
                    </NavLink>
                </li>
                <li>
                    <NavLink className="nav-link" onClick={this.toggleMenu} to='/app/bills' activeClassName="active">
                        <i className="pe-7s-note2 menu-icon"></i>
                        Mes factures
                    </NavLink>

                </li>
                <li className="heading">Mon compte</li>
                <li>
                    <NavLink className="nav-link" onClick={this.toggleMenu} to='/app/profile' activeClassName="active">
                        <i className="pe-7s-user menu-icon"></i>
                        Mon profil
                    </NavLink>

                </li>
                <li>
                    <NavLink className="nav-link" onClick={this.toggleMenu} to='/app/logout' activeClassName="active">
                        <i className="pe-7s-plug menu-icon"></i>
                        Déconnexion
                    </NavLink>

                </li>
            </ul>
        </div>

    );

    return(
        <div className="app-mobile-header-wrapper">
            <div className="app-mobile-header">
                <img className="logo" src={logo} alt="Logo"/>
                <i className="pe-7s-menu hamburger" onClick={this.toggleMenu}></i>
            </div>
            {this.state.isMenuOpen && <hr />}
            {this.state.isMenuOpen && menu}

        </div>
    );
  }
}
export default MobileHeader;



// WEBPACK FOOTER //
// ./src/components/MobileHeader.js